module.exports = __webpack_public_path__ + "img/spitter-run-5.5018a8e7.png";